import React from 'react';

import {
  DATA_TABLE_SOURCE_LISTING_LEAD_HEALTH,
} from 'common/dataTableConstants';

import {
  LISTING_STATUS_ACTIVE,
} from 'common/listingConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrLeadHealthCard from 'client/components/SrLeadHealthCard/SrLeadHealthCard';

function getDataTableSettingsFromProps({
  marketId,
  partnerId,
  accountManagerId,
}) {
  const dataTableSettings = {
    itemsPropName: 'listings',
    dataSource: DATA_TABLE_SOURCE_LISTING_LEAD_HEALTH,
    rootViewId: DATA_TABLE_SOURCE_LISTING_LEAD_HEALTH,
    initialViewSettings: {
      sort: {
        createdDate: 'desc',
      },
      filter: {},
      customParams: {
        listingLeadHealth: {
          status: LISTING_STATUS_ACTIVE,
          unhealthy: true,
        },
      },
    },
    count: 12,
  };

  if (marketId) {
    dataTableSettings.initialViewSettings.customParams.listingLeadHealth.marketId = marketId;
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_marketId:${marketId}`;
  }

  if (partnerId) {
    dataTableSettings.initialViewSettings.customParams.listingLeadHealth.partnerId = partnerId;
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_partnerId:${partnerId}`;
  }

  if (accountManagerId) {
    dataTableSettings.initialViewSettings.customParams.listingLeadHealth.accountManagerId = accountManagerId;
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_accountManagerId:${accountManagerId}`;
  }

  return dataTableSettings;
}

const SrLeadHealthDataTable = ({
  marketId,
  partnerId,
  accountManagerId,
}) => {
  return (
    <SrDataTableConnected
      {...getDataTableSettingsFromProps({
        marketId,
        partnerId,
        accountManagerId,
      })}
    >
      {({ listings, dataTableApiState, onInfiniteScrollWrapperRef, reloadItems }) => {
        return (
          <>
            <div ref={onInfiniteScrollWrapperRef}>
              <SrFlex wrap='wrap' justify='center'>
                {listings.map((leadHealth) => (
                  <SrBox key={leadHealth.id} width='420px' padding='10px'>
                    <SrLeadHealthCard
                      showListingDetails
                      leadHealth={leadHealth}
                      reloadListingNotes={() => {
                        reloadItems({
                          count: 1,
                          filter: { id: leadHealth.id },
                        });
                      }}
                    />
                  </SrBox>
                ))}
              </SrFlex>
            </div>
            {dataTableApiState.inProgress && (
              <SrFlex justify='center'>
                <div className='loading-gif' />
              </SrFlex>
            )}
          </>
        );
      }}
    </SrDataTableConnected>
  );
};

SrLeadHealthDataTable.displayName = 'SrLeadHealthDataTable';

export default SrLeadHealthDataTable;
